"use strict";

var _classCallCheck = require("/home/circleci/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/circleci/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/home/circleci/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/home/circleci/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var luxon_1 = require("luxon");

var belfast_entity_1 = require("@kaizenplatform/belfast-entity");

var ApiFileReference = /*#__PURE__*/function (_belfast_entity_1$Fil) {
  _inherits(ApiFileReference, _belfast_entity_1$Fil);

  var _super = _createSuper(ApiFileReference);

  _createClass(ApiFileReference, null, [{
    key: "fromJSON",
    value: function fromJSON(value) {
      var _Object$assign = Object.assign({}, value),
          id = _Object$assign.id,
          mimetype = _Object$assign.mimetype,
          size = _Object$assign.size,
          originalName = _Object$assign.originalName,
          url = _Object$assign.url,
          _createdAt = _Object$assign.createdAt;

      if (typeof id !== 'string') throw new TypeError('.id must be a string');
      if (typeof mimetype !== 'string') throw new TypeError('.mimetype must be a string');
      if (!Number.isSafeInteger(size)) throw new TypeError('.size must be an integer');
      if (typeof originalName !== 'string') throw new TypeError('.originalName must be a string');
      if (typeof url !== 'string') throw new TypeError('.url must be a string');
      var createdAt = luxon_1.DateTime.fromISO(_createdAt);
      if (!createdAt.isValid) throw new TypeError('.createdAt must be a valid ISO8601 date string');
      return new ApiFileReference({
        id: id,
        mimetype: mimetype,
        size: size,
        originalName: originalName,
        createdAt: createdAt,
        url: "".concat(url, "?download=true")
      });
    }
  }]);

  function ApiFileReference(_ref) {
    var id = _ref.id,
        mimetype = _ref.mimetype,
        size = _ref.size,
        originalName = _ref.originalName,
        createdAt = _ref.createdAt,
        url = _ref.url;

    _classCallCheck(this, ApiFileReference);

    return _super.call(this, {
      id: id,
      mimetype: mimetype,
      size: size,
      originalName: originalName,
      createdAt: createdAt,
      url: url
    });
  }

  return ApiFileReference;
}(belfast_entity_1.FileReference);

exports.default = ApiFileReference;